import type { UseQueryResult } from 'react-query';
import { ISkeletonProps, Skeleton } from '@sixui/ui';

import type { IContainerProps } from '~/components/utils/Container';

export type IQuerySkeletonProps = IContainerProps &
  ISkeletonProps & {
    query: UseQueryResult;
  };

export const QuerySkeleton: React.FC<IQuerySkeletonProps> = (props) => {
  const { sx, query, length, children, ...other } = props;

  return (
    <Skeleton
      sx={sx}
      loaded={!query.isLoading}
      hasError={query.isError}
      length={length}
      {...other}
    >
      {!query.isLoading || !length ? children : undefined}
    </Skeleton>
  );
};
